import React from 'react'

export const UserContext = React.createContext({
  token: undefined,
  bundle: {},
  setToken: () => {},
  logout: () => {},
})
